import ValidationWarning from './validation-warning-component';

import './validation-warning.scss';

const MODULE_NAME = 'app.common.validation-warning';
const module = angular.module(MODULE_NAME, [])
    .directive(ValidationWarning.DIRECTIVE_NAME, ValidationWarning);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/validation-warning/validation-warning-module.js